import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CdpValuationCard from "./component";
import { setRedirectionData } from "../../../au-c2b/au.desktop/components/trade-in-wrapper/actions";

const mapStateToProps = ({
    user: {
        gaId
    },
    checkout: {
        tradeInData
    }
}) => ({
    tradeInData,
    gaId
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setRedirectionDataConnect: setRedirectionData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CdpValuationCard);
